<template>
  <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
    <span v-if="this.grouping != 'continual'" class="dateRanger"> Date range: </span>
    <select v-if="this.grouping != 'continual'" v-model="range">
      <option v-for="dateRange in dateRanges" :value="dateRange.value" :key="dateRange.value">
        {{ dateRange.name }}
      </option>
    </select>
    <span v-if="this.grouping != 'continual'" class="dateGrouper"> Group dates: </span>
    <select v-if="this.grouping != 'continual'" v-model="selected">
      <option v-for="dateGroup in dateGroups" v-bind:value="{ id: dateGroup.value, text: dateGroup.name }"
        :key="dateGroup.name">
        {{ dateGroup.name }}
      </option>
    </select>
    <span id="patientNote" class="coltext msgiconbtn"><img title="Write a note"
        src="https://cdn4.iconfinder.com/data/icons/eon-ecommerce-i-1/32/message_letter_email_mail_send_envelope-512.png"
        width="40" height="40" @click="showNote(patient.id)" /></span>
    <div class="vitalsTimer">
      <span id="timer">{{ showTime() }}</span>
      <button @click="timerClick"> {{ isTimed ? "Stop timer" : "Start timer" }} </button>
      <button v-if="!isTimed" @click="saveTimerNote">Save Time</button>
    </div>
    <br><br>
    <div class="link__container">
      <router-link :to="getVitalsGrouping('all')" class="item__link all">All</router-link>
      <router-link :to="getVitalsGrouping('glucose')" class="item__link glucose">Glucose</router-link>
      <router-link :to="getVitalsGrouping('pulse')" class="item__link pulse">BP</router-link>
      <router-link :to="getVitalsGrouping('weight')" class="item__link weight">Weight</router-link>
      <router-link :to="getVitalsGrouping('breathing')" class="item__link breathing">Sp0<sub>2</sub></router-link>
      <router-link :to="getVitalsGrouping('temperature')" class="item__link temperature">Temp</router-link>
      <router-link :to="getVitalsGrouping('continual')" class="item__link continual">Continual</router-link>
    </div>
    <note-popup ref="notePopup" :type="'9945X'" class="note__popup" :patient="patient" :id="'note__popup' + patient.id" style="display: none" />
    <p v-if="this.grouping != 'continual'" class="mb-md-o mb-0">
      <small class="">
        <strong>
          Toggle <input type="checkbox" class="mr-1 mr-md-1" :checked="checked" @click="checked = !checked" />to {{
            graphOrUngraphMessage }}
        </strong>
      </small>
    </p>
    <!-- <note-popup class="note__popup" :type="'Vitals'" :patient="patient" :id="'note__popup' + patient.id" style="display: none" /> -->
    <vital-signs v-if="this.grouping != 'continual'" :grouping="this.grouping" :range="range"
      :selected="this.selected"></vital-signs>
    <watch-graph v-if="this.grouping != 'continual'" :range="this.range" :selected="this.selected"
      :type="'all'"></watch-graph>

    <cont-graph v-if="this.grouping == 'continual'" :key="keyval" />

    <!-- <watch-list :newestProcedure="procCcd"></watch-list> -->

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { CURR_API, OTHER_API } from '@/constants/apis'
import WatchGraph from "./_partials/watch/Graph";
import WatchList from "./_partials/watch/WatchList";
import VitalSigns from "./_partials/watch/VitalSigns";
import NotePopup from "@/components/private-layouts/NotePopup.vue"
import ContinuousGraph from "./_partials/watch/ContinuousGraph.vue"
import {
  requestVitalSignsCodes
} from '@/api/sessionApi';
import {
  requestExternalMeasures
} from '@/api/dataApi';
import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import { get } from 'http';

export default {
  name: "vitals-group-page",
  props: {
    procCcd: {
      type: Number,
      default: 0
    },
    grouping: {
      type: String,
      default: 'all'
    },

  },
  components: {
    'watch-graph': WatchGraph,
    'watch-list': WatchList,
    'vital-signs': VitalSigns,
    'cont-graph': ContinuousGraph,
    "note-popup": NotePopup,
  },
  data() {
    return {
      checked: false,
      selected: null,
      dateGroups: [
        { name: 'every week', value: 7 },
        { name: 'every 2 weeks', value: 14 },
        { name: 'every 30 days', value: 30 },
        { name: 'every 90 days', value: 90 },
        { name: 'every 365 days', value: 365 },
        { name: 'all', value: 50000 }
      ],
      keyval: this.nextKeyVal() + 'x',
      runningTime: 0,
      isTimed: true,
      interval: null
    }
  },
  watch: {
    '$route'(to, from) {
      let button = document.getElementsByClassName(this.grouping)[0]
      button.style.backgroundColor = '#0c8687'
    },
    allDataLoaded: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (!this.areExternalMeasuresLoaded) {
            let loader = this.$loading.show({}, {
              after: this.$createElement('div', {}, ['Loading data...'])
            });
            if (!this.vitalCcds || this.vitalCcds.length < 1) {
              requestVitalSignsCodes()
                .then((vitalSignCodes) => {
                  this.setVitalSignCodes(vitalSignCodes);
                })
                .then(requestExternalMeasures)
                .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
                  this.addMeasures({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds });
                  this.setExternalMeasuresLoaded(true);
                  this.tapKeyval();
                })
                .then(() => {
                  loader.hide()
                  loader = null
                })
                .catch((err) => {
                  loader.hide()
                  loader = null
                  console.dir(err);
                  alert(err);
                });
            }
            else {
              requestExternalMeasures()
                .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
                  this.addMeasures({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds });
                  this.setExternalMeasuresLoaded(true);
                  this.tapKeyval();
                })
                .then(() => {
                  loader.hide()
                  loader = null
                })
                .catch((err) => {
                  loader.hide()
                  loader = null
                  console.dir(err);
                  alert(err);
                });
            }
          }
        }
      },
      immediate: true
    },
    '$store.state.watch.areExternalMeasuresLoaded'(newValue, oldValue) {
      if (newValue === false) {
        let d1 = Date();
        for (; ;) {
          let d2 = Date();
          if (d1.toString() !== d2.toString())
            break;
        }
        this.keyval = this.nextKeyVal
      }
    }
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function() {
      return this.allData.patient
    },
    externalMeasuresLoaded() {
      return this.$store.state.watch.areExternalMeasuresLoaded;
    },
    allDataLoaded() {
      return this.$store.state.login.phrData && true;
    },
    graphOrUngraphMessage() {
      return this.checked ? 'ungraph' : 'graph'
    },
    range: {
      get() {
        return this.$store.state.login.preferences.daysOfVitalsShown;
      },
      set(value) {
        this.$store.commit('login/preferences/changeDaysOfVitalsShown', value);
      }
    },
    ...mapGetters('login/preferences', {
      dateRanges: 'getDaysofVitalsShownChoices'
    }),
    ...mapGetters('login/watch', {
      measuresWatching: 'getMeasuresWatching',
      proceduresWatching: 'getProceduresWatching',
      checkedMeasures: 'getCheckedMeasures',
      vitalCcds: 'getVitalSignCodes'
    }),
    hasItemInWatchList() {
      return (this.measuresWatching && Object.keys(this.measuresWatching).length > 0)
        || (this.proceduresWatching && Object.keys(this.proceduresWatching).length > 0);
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.runningTime += 1
    }, 1000);
  },
  methods: {
    ...mapActions('login/watch', [
      'setVitalSignCodes',
      'setExternalMeasuresLoaded',
      'resetCheckedVitals'
    ]),
    ...mapActions('login', [
      'addMeasures'
    ]),
    ...mapGetters('login', {
      user: 'getUser'
    }),
    getVitalsGrouping(group) {
      return {
        name: "VitalsGroup",
        params: { grouping: group }
      }
    },
    async saveTimerNote() {
      let post = {
        "API_Meth": "SavePatientNote",
        "PatientNote": new Date().toLocaleString(),
        "patientID": this.patient.externId,
        "pname": this.patient.firstName + " " + this.patient.lastName,
        "notify": this.notify,
        "email": this.patient.email,
        "name": this.allData.manager ? this.allData.manager.name : this.user().firstName + " " + this.user().lastName,
        "startDt": "9999-12-31",
        "endDt": "9999-12-31",
        "startTime": "0:00",
        "endTime": "0:00",
        "type": "Vitals",
        "timeLength": this.runningTime
      }
      await axios.post(CURR_API + "/tswebhook.php", post, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          // console.log(res)
          if (res.data.msg && res.data.msg == "Inserted") {
            alert("Time spent on this page has been saved.")
          }
          else {
            alert("There was an error in saving the time. Please try again or contact a website administrator.")
          }
        })
      this.runningTime = 0
    },
    timerClick() {
      if (this.isTimed) {
        clearInterval(this.interval)
      }
      else {
        this.interval = setInterval(() => {
          this.runningTime += 1
        }, 1000);
      }
      this.isTimed = !this.isTimed
    },
    showTime(){
      let time = this.runningTime
      let hours = Math.floor(time / 3600)
      let newTime = time % 3600
      let minutes = Math.floor(newTime / 60);
      let seconds = newTime % 60;
      if (minutes < 10) minutes = "0"+minutes
      if (seconds < 10) seconds = "0"+seconds
      return "" + hours + ":" + minutes + ":" + seconds
    },
    async showNote(id) {
      this.isTimed = false
      clearInterval(this.interval)
      this.$refs.notePopup.startTimer()
      let content = {
        "systemData": {
          "API_Meth": "GetOrderNumber"
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          let num = res.data.ordernumber
          if (num && num != '') {
            this.orderNum = num
            let note = document.getElementById('note__popup' + id)
            note.style.display = 'flex'
          }
          else
            alert("Error generating order number. Contact an administrator before creating a new order.")
        })
    },
    dateToKeyval(d) {
      return d.toString() + d.getMilliseconds();
    },
    nextKeyVal(d = null) {
      let startDate = d || new Date();
      let c = 0;
      for (; ;) {
        const now = new Date();
        if (this.dateToKeyval(startDate) !== this.dateToKeyval(now)) {

          return this.dateToKeyval(now);
        }
      }
    },
    tapKeyval() {
      this.keyval = this.nextKeyVal();
    },
    loadExternalMeasures() {
      let loader = this.$loading.show({}, {
        after: this.$createElement('div', {}, ['Loading data...'])
      });
      requestExternalMeasures()
        .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
          this.addMeasures({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds });
          this.setExternalMeasuresLoaded(true);
        })
        .then(() => {
          loader.hide()
          loader = null
        })
        .catch((err) => {
          console.dir(err);
          alert(err);
        });
    }
  },
  beforeRouteUpdate(to, from, next) {
    let button = document.getElementsByClassName(this.grouping)[0]
    button.style.backgroundColor = '#49a5a7'
    this.resetCheckedVitals()
    next()
  },
  mounted() {/*
    if (this.getAllData() === null)
      return
    this.resetCheckedVitals()
    let button = document.getElementsByClassName(this.grouping)[0]
    button.style.backgroundColor = '#0c8687'
    if (!this.vitalCcds || this.vitalCcds.length < 1) {
      requestVitalSignsCodes()
        .then((vitalSignCodes) => {
          this.setVitalSignCodes(vitalSignCodes);
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // console.log(this.areExternalMeasuresLoaded)
    if (!this.areExternalMeasuresLoaded) {
      let loader = this.$loading.show({}, {
        after: this.$createElement('div', {}, ['Loading data...'])
      });
      requestExternalMeasures()
        .then(({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds }) => {
          this.addMeasures({ externalMeasures, externalMeasCcdMeasIds, externalMeasCcds });
          this.setExternalMeasuresLoaded(true);
          this.tapKeyval();
        })
        .then(() => {
          loader.hide()
          loader = null
        })
        .catch((err) => {
          console.dir(err);
          alert(err);
          loader.hide()
          loader = null
        });
    } */
  },
  beforeDestroy() {
    delete this.graphOrUngraphMessage;
    delete this.hasItemInWatchList;
  }
}
</script>

<style scoped lang="scss">
.page {
  margin-bottom: 4.0rem;
}

.card-header {
  padding: 0.2rem;
  background-color: #fff;

  a {
    width: 100%;
    text-align: left;
  }
}

.card-body {
  padding: 0;
  font-size: 0.95rem;
}

.btn--remove {
  background-color: transparent;
  margin: 0;
  padding: 0;
  color: #ff4444;

  &:hover {
    color: #cc0000;
  }
}

.item__link {
  display: block;
  width: 100%;
  background-color: #49a5a7;
  color: #fff;
  font-size: 0.9em;
  border-radius: 3px;
  padding: 5px 0;
  text-align: center;
}

.link__container {
  display: grid;
  grid-auto-flow: column;
  column-gap: 20px;
  margin-bottom: 10px;
  width: 100%;
}

.msgiconbtn{
  float:right;
}

.vitalsTimer {
  float:right;
  margin-right: 1%;
}
</style>